export enum NotifStatus {
  Success = 'success',
  Failed = 'failed',
  Info = 'info',
}
